module.exports = __webpack_public_path__ + "static/media/visual_billboard.efb41178.png";